export const modalMessageTransition = {
  entering: { opacity: 0 },
  entered: { opacity: 1 },
  exiting: { opacity: 1 },
  exited: { opacity: 0 }
}

export const modalMessageContentTransition = {
  entering: { transform: 'translateY(-20px)' },
  entered: { transform: 'translateY(0px)' },
  exiting: { transform: 'translateY(-20px)' },
  exited: { transform: 'translateY(-20px)' }
}
